import { css } from 'styled-components';

export const addMenuHeightMixin = css<{ $addMainMenuHeaderHeight: boolean }>`
  ${p =>
    p.$addMainMenuHeaderHeight &&
    Styles.desktop`
      margin-top: 14rem;
    `}
`;
